<template>
  <v-dialog v-model="dialog" persistent max-width="1200px">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" style="text-align: end;">
            <v-btn icon dark @click="$emit('closeModal')" style="color:black  ">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <span> </span>
      </v-card-title>
      <v-container fluid>
        <TableClientes
          :clientes="clientes"
          :total="total"
          :loading="loading"
          @postClienteSelecciondo="postClienteSelecciondo"
          @getClientesPagination="getClientesPagination"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import TableClientes from "./TableClientes.vue";
export default {
  components: {
    TableClientes,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    clientes: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    postClienteSelecciondo(e) {
      this.$emit("postClienteSelecciondo", e);
    },
    getClientesPagination(e) {
      this.$emit("getClientesPagination", e);
    },
  },
};
</script>
